import React from 'react';

import CountryInfo from '../CountryInfo';

const AID_PACKAGE = {
    title: '$82 Billion Aid Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Program Details</p>
            <ul>
                <li>
                    $27 billion in direct supports & $55 billion to help
                    business liquidity through tax deferrals
                </li>
                <li>
                    Temporary income support for workers & parents (includes up
                    to $900 bi-weekly for up to 15 weeks)
                </li>
                <li>
                    Longer-term income support for workers (EI Work Sharing
                    Program)
                </li>
                <li>
                    Income support for individuals who need it most (includes
                    temporary boost to Canada Child Payment benefits)
                </li>
                <li>Flexibility for taxpayers</li>
                <li>
                    $305 million for a new Indigenous Community Support Fund
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'COVID-19 Economic Response Plan: Support for Canadians and Businesses',
            url: 'https://www.canada.ca/en/department-finance/news/2020/03/canadas-covid-19-economic-response-plan-support-for-canadians-and-businesses.html',
        },
    ],
};

const BCAP_SECTION = {
    title: 'Business Credit Availability Program (BCAP)',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Program Details</p>
            <ul>
                <li>
                    Increasing liquidity for Canadian businesses experiencing
                    cash flow challenges by strengthening investment in federal
                    lending agencies such as the Business Development Bank of
                    Canada (BDC) should the economy experience tightening
                    conditions.
                </li>
                <li>
                    BDC (Bank of Canada) and EDC (Export Development Canada)
                    will provide more than $10 billion of additional support to
                    businesses.
                </li>
                <li>
                    Office of the Superintendent of Financial Institutions
                    (OSFI) will lower the Domestic Stability Buffer requirement
                    for domestic systemically important banks by 1.25% of risk
                    weighted assets, effective immediately.
                </li>
                <li>
                    Release of the buffer will support in excess of $300 billion
                    of additional lending capacity.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Small Business Loan Information',
            url: 'https://www.bdc.ca/en/financing/business-loans/pages/small-business-loan.aspx',
        },
        {
            title: 'Small Business Loan Application',
            url: 'https://www.bdc.ca/en/online_financing/pages/loan-application.aspx',
        },
        {
            title: 'Working Capital Loan - Applications for either less than or more than $100,000',
            url: 'https://www.bdc.ca/en/financing/business-loans/working-capital-financing/pages/working-capital-loan.aspx',
        },
    ],
};

const EI_SECTION = {
    title: 'Employment Insurance (EI) Benefits',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Program Details</p>
            <ul>
                <li>
                    Provides up to 15 weeks of income replacement and is
                    available to eligible claimants who are unable to work
                    because of illness, injury or quarantine, to allow them time
                    to restore their health and return to work. Canadians
                    quarantined can apply for Employment Insurance (EI) sickness
                    benefits.
                </li>
                <li>
                    One-week waiting period for EI sickness benefits will be
                    waived for new claimants who are quarantined so they can be
                    paid for the first week of their claim.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Application for EI sickness benefits',
            url: 'https://www.canada.ca/en/services/benefits/ei/ei-sickness/apply.html',
        },
    ],
};

const BANK_CANADA_SECTION = {
    title: 'Bank of Canada Response',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4"></p>
            <ul>
                <li>
                    Will broaden the scope of the current Government of Canada
                    bond buyback program to add market liquidity and support
                    price discovery.
                </li>
                <li>
                    Buybacks will extend across all benchmark maturity sectors
                    and will be conducted at least weekly.
                </li>
                <li>
                    Temporarily add new Term Repo operations with terms of 6 and
                    12 months.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Bank of Canada Announces the Expansion of its Bond Buyback Program and Term Repo Operations',
            url: 'https://www.bankofcanada.ca/2020/03/expansion-bond-buyback-term-repo/',
        },
    ],
};

const PRIVATE_PROGRAMS_SECTION = {
    title: 'Private Company Programs',
    subSections: [
        {
            title: 'Plastiq Financing',
            infoLink: 'https://www.plastiq.com/eventbrite/',
            content: (
                <p>
                    Use your existing credit with Plastiq to pay your lease,
                    utilities, contractors, and vendors by using your business
                    credit card, even if they don&apos;t accept credit cards.
                    You&apos;ll pay a 2.5% fee and repay the expense in 30+
                    days.
                </p>
            ),
        },
    ],
    links: [],
};

const COUNTRY_INFO = {
    countryName: 'Canada',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Canada has multiple different financial assistance options
            available. Please look over this information and follow up as
            appropriate.
        </p>
    ),
    sections: [
        AID_PACKAGE,
        BCAP_SECTION,
        EI_SECTION,
        BANK_CANADA_SECTION,
        PRIVATE_PROGRAMS_SECTION,
    ],
};

const CanadaInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default CanadaInfo;
